import React, { useState, useEffect } from "react";
import Top from "./Top Section/Top";
import SellerTable from "./SellerTable";
import Pagination from "../../../common/pagination";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import { paginate } from "../../../utils/paginate";
import { CSVLink, CSVDownload } from "react-csv";
import Tracker from "./../../../common/tracker";
import Payment from "../../../common/payment";
import getService from "../../../services/getService";
import Loader from "./../../../common/loader";
import NoCart from "../../../common/noCart";
import { toast } from "react-toastify";
import postService from "../../../services/postService";

const SellerOrder = ({ myAccount }) => {
  const [orders, setOrders] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const ZeroOrder = () => {
    setOrders([]);
    setLoading(true);
  };

  const AllOrder = (list) => {
    const data = list.order_list.map(({ target_price: price, ...rest }) => ({
      price,
      ...rest,
    }));
    console.log("data", data);
    const sortedDateArray = data.sort((a, b) => {
      const date1 = new Date(a.order_date);
      const date2 = new Date(b.order_date);
      return date2 - date1;
    });
    // const filteredArray = sortedDateArray.filter(filter => filter.status === "Active");
    setOrders(sortedDateArray);
    setLoading(true);
  };

  const fetchOrderList = async (myAccount) => {
    const list = await getService.handleSellerOrderList({
      user_id: myAccount.id,
      token: myAccount.token,
    });
    list === null ? ZeroOrder() : AllOrder(list);
  };

  useEffect(() => {
    fetchOrderList(myAccount);
  }, [myAccount]);

  const handlePayment = () => {
    console.log("handle payment");
  };

  const handleTracker = async (data) => {
    try {
      await postService.PostTracker(data);
      setCurrentPage(1);
      fetchOrderList(myAccount);
    } catch (error) {
      toast.error(error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getPagedData = () => {
    const order = paginate(orders, currentPage, pageSize);
    return { totalCount: orders.length, data: order };
  };

  const { totalCount, data: order } = getPagedData();

  const columns = [
    {
      key: "",
      label: "S.No",
      content: (order) => <p>{orders.indexOf(order) + 1}</p>,
    },
    // {path: "customer", label: "Customer"},
    { path: "post_requirement_id", label: "Order Id" },
    { path: "order_date", label: "Date" },
    { path: "amount", label: "Amount" },

    {
      key: "Tracker",
      label: "Tracker",
      content: (order) => (
        <>
          {" "}
          <Tracker
            tracker={order.order_tracker}
            userType={myAccount.user_type}
            handleTracker={handleTracker}
          />
        </>
      ),
    },
    {
      key: "Payment",
      label: "Payment",
      content: (order) => (
        <>
          {" "}
          <Payment
            pay={order.payment_tracker}
            payment_status={order.payment_status}
            userType={myAccount.user_type}
            handlePayment={handlePayment}
          />
        </>
      ),
    },
    {
      path: "orderStatus",
      label: "Order Status",
      content: (order) => <p>{order.order_tracker_status}</p>,
    },
    {
      key: "Invoice",
      label: "Invoice",
      content: (order) => (
        <Link
          style={{ textAlign: "center" }}
          class="btn btn-primary btn-sm"
          to={`/sellerdashboard/Orders/Invoices/${order.post_requirement_id}`}
          state={{ data: order.invoice_list, order: order }}
        >
          <i class="fa fa-eye" aria-hidden="true"></i>
        </Link>
      ),
    },
    // {
    //   key: "PO",
    //   label: "PO",
    //   content: (order) => (
    //     <>
    //       {order.invoice_list && (
    //         <Link
    //           style={{ textAlign: "center" }}
    //           class="btn btn-warning btn-sm"
    //           to={`/sellerdashboard/Orders/Invoice/${order.invoice_list[0].id}`}
    //           state={{ data: order.invoice_list[0], order: order }}
    //         >
    //           <i class="fa fa-first-order" aria-hidden="true"></i>
    //         </Link>
    //       )}
    //     </>
    //   ),
    // },
  ];

  if (loading === false) return <Loader />;

  console.log("orders", order);

  return (
    <>
      {totalCount === 0 && <NoCart />}

      {totalCount !== 0 && (
        <div className="mainContent">
          <Top />
          <div>
            <CSVLink data={orders} className="btn btn-outline-success">
              Download Report
            </CSVLink>
          </div>
          <SellerTable columns={columns} data={order} />

          <Pagination
            itemsCount={totalCount}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </>
  );
};

export default SellerOrder;
